module.exports = __webpack_public_path__ + "static/media/DaxlinePro-Medium.8feadfcb.ttf";